import { useRelatedProducts } from 'react-instantsearch';
import { AlgoliaFinishHit } from '../../types/AlgoliaTypes';
import { FinishCard } from '../FinishCard/FinishCard';

interface RecommendedMaterialsProps {
    objectID: string[]
    limit: number
}

export default function RecommededMaterials({ objectID, limit }: RecommendedMaterialsProps) {

    const relatedProducts = useRelatedProducts<AlgoliaFinishHit>({
        objectIDs: objectID,
        limit: limit
    })

    return (
        <div className={"finish-card__list"}>
            {
                relatedProducts.items.map((item, idx) => {
                    return (
                        <FinishCard finish={item} key={`${item.objectID}-${idx}`}/>
                    )
                })
            }
        </div>
    )
}